import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { VerifyCRL as VerifyCRLReq } from "../../../routes/cryptography";
import { Buffer } from "buffer"


class VerifyCrl extends Component {
    constructor() {
        super();
        this.state = {
            dataCRL: {
                dataCert: "",
                crl: "",
                status: "",

            },
            certFileName: "файл",
            crlFileName: "файл",
            certsFileIsOpen: false,
            crlFileIsOpen: false,
            isValidCertFileSize: true,
            isValidCRLFileSize: true,

            errors: {},
        };
        this.handleFileCRLChange = this.handleFilePrivKeyChange.bind(this);
        this.handleFileCertChange = this.handleFileCertChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleFileCertChange() {
        try {
            const file = document.getElementById("fileCert").files[0];
            //console.log(file);

            if (file !== undefined && file.size < 20000000) {

                this.setState({ certFileName: file.name, isValidCertFileSize: true, certsFileIsOpen: true });
                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => {
                    const buffer = reader.result;

                    const data = new Buffer(new Uint8Array(buffer)).toString();
                    this.setState({
                        dataCRL: { ...this.state.dataCRL, dataCert: data },
                    });

                };
                reader.onerror = (e) => {
                    console.error(e);
                };
            } else {
                this.setState({ certFileName: "файл", isValidCertFileSize: false, certsFileIsOpen: false });
            }
        } catch (error) {
            //console.log(error);
        }
    }
    handleFilePrivKeyChange() {
        try {
            const file = document.getElementById("fileCRL").files[0];
            //console.log(file);

            if (file !== undefined && file.size < 20000000) {
                this.setState({ crlFileName: file.name, isValidCRLFileSize: true, crlFileIsOpen: true });
                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => {
                    const buffer = reader.result;

                    const data = new Buffer(new Uint8Array(buffer)).toString();

                    this.setState({
                        dataCRL: { ...this.state.dataCRL, isValidCRLFileSize: false, crl: data },
                    });
                };
                reader.onerror = (e) => {
                    console.error(e);
                };
            } else {

                this.setState({ crlFileName: "файл", isValidCRLFileSize: false, crlFileIsOpen: false });
            }
        } catch (error) {
            //console.log(error);
        }
    }


    handleSubmit(e) {
        e.preventDefault();
        try {
            //console.log(`Cert: ${this.state.dataCRL.dataCert}`);
            //console.log(`Key: ${this.state.dataCRL.crl}`);

            VerifyCRLReq(
                this.state.dataCRL.crl,

                this.state.dataCRL.dataCert,
            ).then((result) => {
                try {
                    //console.log(result);
                    try {
                        //console.log(result);
                        if (result.status === 200) {
                            document.getElementById("view").style.borderColor = "green";

                            this.setState({
                                dataCRL: { ...this.state.dataCRL, status: "Успешная проверка СОС" }
                            });
                        } else {
                            document.getElementById("view").style.borderColor = "red";

                            this.setState({
                                dataCRL: {
                                    ...this.state.dataCRL,
                                    status: "Неуспешная проверка СОС"
                                }
                            });
                        }
                    } catch (error) {
                        document.getElementById("view").style.borderColor = "red";

                        //console.log(error);
                    }
                } catch (error) {
                    //console.log(error);
                }
            });
        } catch (error) {
            //console.log(error);
        }
    }

    render() {
        return (
            <div className="container">
                <h4 className="major">Проверка СОС</h4>
                <Form onSubmit={this.handleSubmit}>
                    <div className="sm-4">
                        <Form.Group
                            style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
                        >
                            <Form.Label>Выберите сертификат</Form.Label>
                            <Form.File custom>
                                <Form.File.Input
                                    id="fileCert"
                                    onChange={this.handleFileCertChange}
                                    isValid={this.state.certsFileIsOpen}
                                    isInvalid={!this.state.isValidCertFileSize}
                                    required

                                />
                                <Form.File.Label data-browse="Выбрать">
                                    {this.state.certFileName}
                                </Form.File.Label>
                                <Form.Control.Feedback type="valid" />
                                <Form.Control.Feedback type="invalid">
                                    максимальный размер файла 20мб
                                </Form.Control.Feedback>
                            </Form.File>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Выберите СОС</Form.Label>
                            <Form.File custom>
                                <Form.File.Input
                                    id="fileCRL"
                                    onChange={this.handleFileCRLChange}
                                    isValid={this.state.crlFileIsOpen}
                                    isInvalid={!this.state.isValidCRLFileSize}

                                    required
                                />
                                <Form.File.Label data-browse="Выбрать">
                                    {this.state.crlFileName}
                                </Form.File.Label>
                                <Form.Control.Feedback type="valid" />
                                <Form.Control.Feedback type="invalid">
                                    максимальный размер файла 20мб
                                </Form.Control.Feedback>
                            </Form.File>
                        </Form.Group>
                        <Form.Label style={{ float: "left" }}>
                            {this.state.dataCRL.status}
                        </Form.Label>
                        <Button
                            style={{ float: "right" }}
                            variant="success"
                            type="submit"
                            size="sm"
                        >
                            Проверить
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
}
export default connect()(withRouter(VerifyCrl));
